<template>
  <div class="button-wrap">
    <V-Button
      :callback="findEmail"
      :text="'Find Email'"
      :loading="loading"
    ></V-Button>
  </div>
</template>

<script>
import { get } from '@/assets/util/rest.js'
import button from '@/components/Button'
import sharedFunctions from '@/assets/util/functions.js'
import { MxEvent } from '@/assets/util/constants/analytics'
import { checkAndShowG2ReviewPopup } from '@/assets/util/commonUtil'

export default {
  name: 'FindEmailButton',
  props: [
    'contactCompany',
    'contactName',
    'masterContactId',
    'fromBulk',
    'fromLiSingle',
    'showUpgradePopup',
    'enableReviewPopup',
    'showActivationPopup',
    'showLinkedInConnect',
    'enableSalesgearPromotionPopup',
  ],
  data: function () {
    return {
      loading: false,
      isPaidUser: this.$store.state.header.isPaidUser,
      isLinkedFollowed: this.$store.state.header.linkedinFollow,
    }
  },
  computed: {
    autoTrigger() {
      return this.$store.state.linkedin.autoTrigger
    },
    liUserDataAvailable() {
      return this.$store.state.liData
    },
    lbCreditsPlan() {
      return this.$store.state.header.lbCreditsPlan
    },
  },
  components: {
    'V-Button': button,
  },
  methods: {
    getFindEmailUrl() {
      let url = `li/contact/${this.masterContactId}.htm`
      if ((this.fromLiSingle || this.fromBulk) && this.liUserDataAvailable) {
        //liUserDataAvailable - is linkedin user data received from plugin - for backward compatibility
        url = `li/contact/v2/${this.masterContactId}.htm`
      }
      return url
    },
    findEmail() {
      let snParams = this.$store.state.isSalesNavigator ? '&sn=true' : ''
      let that = this
      this.loading = true
      let url = this.getFindEmailUrl()
      url = `${url}?${snParams}`
      get(url)
        .then((response) => {
          switch (response.status) {
            case 200:
              response.json().then((res) => {
                this.sendEmailFoundResponse(res, that)
                this.trackSingleContactPurchase(res)
              })
              break
            case 419:
              // views exhausted
              that.loading = false
              this.showUpgradePopup('views')
              break
            case 423:
              // bulk views exhausted
              that.loading = false
              this.showUpgradePopup('bulk')
              break
            case 402:
              that.loading = false
              this.showUpgradePopup('daily_limit')
              break
            case 412:
              that.loading = false
              this.showActivationPopup()
              break
            case 417:
              that.loading = false
              this.showLinkedInConnect()
              break
            case 424:
              that.loading = false
              this.showUpgradePopup('sales_navigator')
              break
            case 420:
              that.loading = false
              this.showUpgradePopup('credit_limit')
              break
            case 400:
              that.loading = false;
              this.showUpgradePopup('fair_usage_limit')
          }
        })
        .catch((e) => {
          this.loading = false
          console.log('error: ' + e)
        })
    },
    sendEmailFoundResponse(res, that) {
      const previousCredits = this.$store.state.header.credits
      if (this.lbCreditsPlan) this.$store.state.header.credits = res.creditsLeft
      else this.$store.state.header.views = res.viewsLeft
      this.$store.state.user.phoneNumberEnabled = res.phoneNumberEnabled
      let responseJson = { email: null, phone: null, masterContactId: null }
      if (res && res.emailInfo) {
        let emailInfo = res.emailInfo
        responseJson = {
          email: emailInfo.email,
          phone: emailInfo.phone,
          masterContactId: emailInfo.mcId,
        }
      }
      setTimeout(function () {
        that.loading = false
        that.$emit('response', responseJson)
      }, 500)
      this.emailFoundPostProcessing(previousCredits)
    },
    emailFoundPostProcessing(previousCredits) {
      let count = 0
      const prevCount = localStorage.getItem('emails_found')
      prevCount ? (count = prevCount) : ''
      localStorage.setItem('emails_found', parseInt(count) + 1)
      const that = this
      setTimeout(function () {
        if (checkAndShowG2ReviewPopup(that.$store.state.header.userType, previousCredits, that.$store.state.header.credits)) {
          that.enableReviewPopup()
        } else if (that.checkLiButtonEnable() && that.canShowLinkedInFollow()) {
          that.showUpgradePopup('linkedin_follow')
        }
      }, 1000)
    },
    canShowLinkedInFollow() {
      if (this.emailsFound() == null || this.emailsFound() < 12) {
        return false
      }
      const _KEY = 'linkedin_follow_msg_shown'
      const alreadyShown = localStorage.getItem(_KEY)
      if (alreadyShown || this.$store.state.header.isPaidUser) {
        return false
      } else if (this.$store.state.header.canShowLinkedinFollow) {
        localStorage.setItem(_KEY, true)
        return true
      }
    },
    emailsFound() {
      return localStorage.getItem('emails_found')
    },
    checkLiButtonEnable() {
      return !this.isLinkedFollowed && !this.isPaidUser
    },
    isAmericanUser() {
      if (
        Intl &&
        Intl.DateTimeFormat() &&
        Intl.DateTimeFormat().resolvedOptions() &&
        Intl.DateTimeFormat().resolvedOptions().timeZone
      ) {
        const timezone = Intl.DateTimeFormat().resolvedOptions().timeZone
        if (timezone && timezone.toLowerCase().indexOf('america') !== -1) {
          return true
        } else {
          return false
        }
      }
    },
    trackSingleContactPurchase(response) {
      const email = response.emailInfo.email
      sharedFunctions.track(
        this.$store.state.isSalesNavigator
          ? MxEvent.singleContactPurchasedSN
          : MxEvent.singleContactPurchased,
        {
          contactName: this.contactName,
          contactEmail: email,
          contactCompany: this.contactCompany,
        },
        this.$store.state
      )
    },
  },
  created() {
    if (this.autoTrigger) {
      this.findEmail()
      this.$store.state.linkedin.autoTrigger = false
    }
  },
}
</script>

<style lang="scss">
.button-wrap .but {
  width: 102px;
  font-size: 12px;
  line-height: 18px;
  position: relative;
  padding: 2px 8px;
  background: rgba(38, 72, 247, 0.05);
  border: 1.5px solid rgba(38, 72, 247, 0.2);
  border-radius: 6px;
  color: #2648f7;

  &:hover {
    background: #2648f7;
    border-color: #2648f7;
    color: #fff;
  }
}
</style>
